import type { CatalogData, ThroughputPoint } from '@/types';

const hashCatalogSnapshot = (catalog: CatalogData | null | undefined): string => {
  if (!catalog) {
    return 'null';
  }
  try {
    return JSON.stringify(catalog);
  } catch (error) {
    console.warn('[CatalogSnapshot] Failed to hash catalog snapshot', error);
    return `error-${Date.now()}`;
  }
};

const getCatalogKey = (catalog: CatalogData | null | undefined): string => {
  if (!catalog) return 'null';
  const accelerator = catalog.accelerator?.accelerator_id ?? 'unknown';
  const server = catalog.server?.server_sku ?? 'unknown';
  const throughputCount = catalog.throughput?.length ?? 0;
  const modelsCount = catalog.models?.length ?? 0;
  return `${accelerator}|${server}|${throughputCount}|${modelsCount}`;
};

const getCatalogThroughputVersion = (catalog: CatalogData | null | undefined): number => {
  if (!catalog || !Array.isArray(catalog.throughput)) {
    return 0;
  }
  return catalog.throughput.reduce((version, point, index) => {
    const idCandidate = resolveThroughputVersionCandidate(point, index);
    return idCandidate > version ? idCandidate : version;
  }, 0);
};

const resolveThroughputVersionCandidate = (point: ThroughputPoint, fallbackIndex: number): number => {
  if (typeof point.id === 'number' && Number.isFinite(point.id)) {
    return point.id;
  }
  return fallbackIndex;
};

const cloneCatalogData = (catalog: CatalogData): CatalogData => {
  const cloner = typeof globalThis.structuredClone === 'function' ? globalThis.structuredClone : null;
  if (cloner) {
    return cloner(catalog);
  }
  return JSON.parse(JSON.stringify(catalog)) as CatalogData;
};

export {
  cloneCatalogData,
  getCatalogKey,
  getCatalogThroughputVersion,
  hashCatalogSnapshot,
};
